var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.configUrl)?_c('v-icon',{staticClass:"ml-1 mb-1 pointer",attrs:{"size":"18","color":"primary"},on:{"click":_vm.openDocument}},[_vm._v(" $vuetify.icons.questionCircle ")]):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }